export enum ERankingCategoryMode {
    ALL = "All",
    CATEGORY = "Category",
    SUB_CATEGORY = "Sub-Category",
}
